export default __webpack_public_path__ + "static/media/francheville04.7b70c4e4.jpg";